// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + "850e8f71" + "." + "53caf35f0a898a3d4fbe" + ".js";
};